import React from 'react';
import { Avatar, Icon, Lbl, Token } from './components.jsx';
import { ME, PEOPLE } from './data.jsx';

/** 사람 여러 명 고르기 — 이름·부서·이메일로 찾는다 (회의 참석자 등). 나 자신은 includeMe일 때만(예: 설비 담당자) */
function PeoplePicker({ label = '참석자', value, onChange, max = 100, includeMe = false }) {
  const [q, setQ] = React.useState('');
  const chosen = value.map(id => PEOPLE.find(p => p.id === id)).filter(Boolean);
  const k = q.trim().toLowerCase();
  const hits = k ? PEOPLE.filter(p => (includeMe || p.id !== ME.id) && !value.includes(p.id)
    && [p.name, p.dept, p.email].some(v => String(v || '').toLowerCase().includes(k))).slice(0, 6) : [];
  return (
    <div>
      <Lbl style={{ marginBottom: 8 }}>{label}{chosen.length ? ` ${chosen.length}명` : ''}</Lbl>
      {chosen.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 7 }}>
          {chosen.map(p => (
            <Token key={p.id} tone="accent" onRemove={() => onChange(value.filter(x => x !== p.id))} removeLabel={`${p.name} 빼기`}>{p.name}</Token>))}
        </div>)}
      <div style={{ position: 'relative' }}>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="이름·부서로 찾기" disabled={value.length >= max}
          style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid var(--line-strong)', borderRadius: 'var(--r-ctl)', background: 'var(--surface)', color: 'var(--ink)', fontSize: 12.5 }} />
        {hits.length > 0 && (
          <div className="panel" style={{ position: 'absolute', left: 0, right: 0, top: 'calc(100% + 4px)', zIndex: 5, padding: 4 }}>
            {hits.map(p => (
              <button key={p.id} onClick={() => { onChange([...value, p.id]); setQ(''); }}
                style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left', padding: '6px 8px', borderRadius: 'var(--r-sm)', fontSize: 12.5 }}>
                <Avatar name={p.name} size={20} />{p.name}
                <span style={{ color: 'var(--ink-3)', fontSize: 11 }}>{p.title} · {p.dept}</span>
              </button>))}
          </div>)}
      </div>
    </div>
  );
}

export { PeoplePicker };
